import { formatTime } from "../../../utils/timeConversion";
import { getVoyageNumber } from "../../../utils/domainSelectors";
import { getSelectedCargo, getSelectedTrip } from "../../../utils/voyageSelection";

const resolveOperationLabel = (trip, t) =>
  trip?.operationType === "Discharging"
    ? t("forprint.discharge")
    : t("forprint.load");

const formatPresentedQuantity = (value) => {
  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) {
    return String(value ?? "");
  }

  return numericValue.toLocaleString("en-GB").replace(/,/g, " ");
};

const formatPresentedUnit = (value) =>
  String(value || "").replace(/\bm3\b/gi, "m³");

export const createNorPrintViewModelV2 = ({
  currentVoyage,
  selectedTripId,
  selectedCargoIndex,
  companyLogo,
  retendered = false,
  is24Hour,
  callSign = "",
  date,
  t,
}) => {
  const selectedTrip = getSelectedTrip(currentVoyage, selectedTripId);
  const selectedCargo = getSelectedCargo(
    currentVoyage,
    selectedTripId,
    selectedCargoIndex
  );

  if (!selectedCargo) {
    throw new Error(t("forprint.selectCargoBeforePrint"));
  }

  return {
    companyLogo,
    vesselName: currentVoyage?.vessel || currentVoyage?.vesselName || "",
    vesselIdentityLine: `${currentVoyage?.vessel || currentVoyage?.vesselName || ""} ${callSign}`.trim(),
    voyageNumber: getVoyageNumber(currentVoyage),
    cargoName: selectedCargo?.cargo || selectedCargo?.productName || "",
    cargoQuantity: selectedCargo?.quantity ?? "",
    cargoQuantityDisplay: formatPresentedQuantity(selectedCargo?.quantity),
    cargoUnit: selectedCargo?.unit || "",
    cargoUnitDisplay: formatPresentedUnit(selectedCargo?.unit),
    receiverName:
      selectedTrip?.supplierReceiver ||
      selectedTrip?.counterpartyNameSnapshot ||
      "",
    portName: selectedTrip?.from || selectedTrip?.portNameSnapshot || "",
    jettyName: selectedTrip?.jetty || selectedTrip?.jettyNameSnapshot || "",
    documentDate: date || "",
    operationLabel: resolveOperationLabel(selectedTrip, t),
    tenderedDate: selectedCargo?.activities?.["nor-tendered"]?.date || "",
    tenderedTime: formatTime(
      selectedCargo?.activities?.["nor-tendered"]?.time,
      is24Hour
    ),
    masterName:
      selectedTrip?.crew?.masterName ||
      selectedTrip?.masterSnapshot?.name ||
      "",
    retendered,
  };
};
